<template>
  <div :class="{'mobile-table': true, 'full-page': fullPage}">
    <ul>
      <slot />
    </ul>
  </div>
</template>

<style scoped>
.mobile-table {
  background-color: #ffffff;
}
.mobile-table.full-page {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.mobile-table ul {
  padding: 0;
  margin: 0;
}
</style>

<script>
export default {
  name: 'MobileTable',
  props: {
    fullPage: {
      type: Boolean,
      default: false
    }
  }

}
</script>
